import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { VerticalListComponent } from './vertical-list/vertical-list.component';
import { VerticalFormComponent } from './vertical-form/vertical-form.component';

const routes:Routes =[
  {
    path:'',
    data:{
      title:'Vertical'
    },
    component:VerticalListComponent
  },
  {
    path:'add',
    data:{
      title:'Add Vertical'
    },
    component:VerticalFormComponent
  },
  {
    path:'edit/:id',
    data:{
      title:'Edit Vertical'
    },
    component:VerticalFormComponent
  }
]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes)
  ],
  exports:[RouterModule]
})
export class VerticalRoutingModule { }
